import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { FlowsDisplayGridRowDataFragment, FlowSortOrder, LensUpstreamFlowsQuery, LensUpstreamFlowsQueryVariables , LensUpstreamFlowsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { FlowsDisplayGrid, FlowsDisplayGridRowData, getRowDataForFlow } from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = LensUpstreamFlowsQueryVariables;
type QueryResults = LensUpstreamFlowsQuery;
type QueryResultListNode = FlowsDisplayGridRowDataFragment;
type GridRowData = FlowsDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses[0] && resultData.lenses[0].upstreamFlowsConnection;
}

export type LensUpstreamFlowsQueryGridProps =
  GridSortProps<FlowsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export const LensUpstreamFlowsQueryGrid: React.FC<LensUpstreamFlowsQueryGridProps> = props => {
  const emptyGridMessage = Messages.EmptyUpstreamFlowsLineageGridMessage();

  return (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={LensUpstreamFlowsDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as FlowSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForFlow}
    >
      {({ rowStore }) =>
        <FlowsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
};
